import { useState } from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import {
  LeaderboardBreadcrumb,
  LeaderboardOrgDetail,
  LeaderboardPageHeader,
  LeaderboardPageShell,
  LeaderboardRankingTable,
  LeaderboardStatGrid,
} from "./LeaderboardShared";
import { leaderboardPeriodOptions } from "data/leaderboardDemoData";

/**
 * One leaderboard category (pilot, airport, or nonprofit network table) with optional context banner.
 */
function SingleCategoryLeaderboardView({
  title,
  subtitle,
  stats,
  tableTitle,
  searchPlaceholder,
  columns,
  rows,
  entityType,
  filterKeys,
  highlightBanner = null,
}) {
  const [period, setPeriod] = useState(leaderboardPeriodOptions[0]);
  const [detail, setDetail] = useState(null);

  if (detail) {
    return (
      <LeaderboardPageShell>
        <LeaderboardBreadcrumb current={detail.row.name} />
        <Box sx={{ mt: 2 }}>
          <LeaderboardOrgDetail
            entityType={entityType}
            row={detail.row}
            onBack={() => setDetail(null)}
          />
        </Box>
      </LeaderboardPageShell>
    );
  }

  return (
    <LeaderboardPageShell>
      <LeaderboardBreadcrumb current="Leaderboards" />
      <LeaderboardPageHeader
        title={title}
        subtitle={subtitle}
        period={period}
        onPeriodChange={setPeriod}
      />
      <Box sx={{ mt: 3 }}>
        {highlightBanner ? (
          <Box sx={{ mb: 2 }}>
            <Alert severity="info">{highlightBanner}</Alert>
          </Box>
        ) : null}
        <LeaderboardStatGrid stats={stats} />
        <LeaderboardRankingTable
          title={tableTitle}
          searchPlaceholder={searchPlaceholder}
          columns={columns}
          rows={rows}
          getRowId={(r) => r.id}
          onRowClick={(r) => setDetail({ row: r, entityType })}
          filterKeys={filterKeys}
        />
      </Box>
    </LeaderboardPageShell>
  );
}

export default SingleCategoryLeaderboardView;
